import React from 'react';
import styles from '../../../../searchV2.scss';
import LocationSearch from './LocationSearch';
import DistanceSlider from './DistanceSlider';

const LocationFilterDropdown = props => {
    const { value, geoLocation, handleLocationChange, handleLocationSelect, handleCurrentLocationClick, distance, handleDistanceChange } = props;

    return (
        <div className={styles.locationFilterContent}>
            <div className={styles.locationInputSection}>
                <LocationSearch
                    className={`form-control ${styles.locationSearchInput}`}
                    value={value}
                    geoLocation={geoLocation}
                    onChange={(location) => handleLocationChange(location)}
                    handleClearClick={(callback) => {
                        handleLocationChange('');
                        if (callback) {
                            callback();
                        }
                    }}
                    onSelect={(location) => handleLocationSelect(location)}
                    onCurrentLocationClick={handleCurrentLocationClick}
                />
            </div>

            <div className={styles.currentLocationSection}>
                <div className={styles.currentLocationButton} onClick={handleCurrentLocationClick}>
                    <img src="/img/v4/current-location-icon.svg" alt="Current Location" />
                    Click to use current location
                </div>
            </div>
            <div className={styles.distanceSection}>
                <DistanceSlider
                    distance={distance}
                    handleDistanceChange={handleDistanceChange}
                />
            </div>
        </div>
    );
};

export default LocationFilterDropdown;
